import { useShellStore } from '@/store'
import { computed } from 'vue'
import { AuthStore, Channel } from 'frontendcommon-3'

export function useSettingsShell (props) {
  const shellStore = useShellStore()
  const settingsItemId = computed(() => shellStore.settingsItemId)
  const settingsShell = computed(() => shellStore.settingsShell)
  const hasSettingsShell = computed(() => AuthStore.getPermissions().settingsShell && props.showSettingShell)

  function updateSettingsShellState (isOpen) {
    Channel.emitSettingsModalState(isOpen)
    shellStore.SET_SETTINGS_SHELL(isOpen)
    if (!isOpen) shellStore.SET_SETTINGS_ITEM_ID('')
  }

  function updateSettingsShellItemId (itemId) {
    shellStore.SET_SETTINGS_ITEM_ID(itemId)
  }

  return {
    settingsShell,
    settingsItemId,
    updateSettingsShellState,
    updateSettingsShellItemId,
    hasSettingsShell
  }
}
